import React from "react";
import "./styles/Hero.css";
import Portada from "../images/javascript.svg";
import Fade from "react-reveal/Fade";
import Button from "./ui/Button";
import { css } from "@emotion/core";
const Hero = () => {
  return (
    <>
      <Fade>
        <section className="c-hero">
          <div className="hero-message">
            Hola, soy Isaías Chávez un estudiante de Ingeniería con pasión por
            el desarrollo web. Las inversiones y el aprendizaje continuo.
            <p>
              <span>¿Interesado en trabajar conmigo? </span>
            </p>
            <Button to="/contact">Mandame un mensaje</Button>
          </div>

          <img src={Portada} className="hero-image" alt="" />
        </section>
      </Fade>
    </>
  );
};

export default Hero;
